controllers.controller('OtpController', [
    '$scope', 'LocaleService', 'config', 'API', 'UserService', '$q', 'ionicToast',
    function ($scope, LocaleService, Config, API, UserService, $q, ionicToast) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.user = UserService.get();

        $scope.showSpinner = false;

        $scope.otp = {
            qrcode: undefined,
            secret: '',
            code: '',
            enabled: $scope.user.otpEnabled
        };

        $scope.formV = undefined;

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.config = Config;

        $scope.OnOtpChange = function (){
            if ($scope.otp.enabled) {
                $scope.getOtp();
            }
        };

        $scope.verifyOtp = function (){
            $scope.toggleOtp(!$scope.user.otpEnabled);
        };


        $scope.getOtp = function () {
            $scope.showSpinner = true;

            return API.getOTP()
                .then(function (response) {
                    $scope.showSpinner = false;
                    $scope.otp.qrcode = 'data:image/png;base64,' + response.qrcode;
                    $scope.otp.secret = response.secret;
                })
                .catch(function (error) {
                    $scope.showSpinner = false;
                });
        };

        $scope.toggleOtp = function (enable) {
            $scope.showSpinner = true;

            var request = {
                login: $scope.user.login,
                otpCode: $scope.otp.code,
                enable: enable && 1 || 0
            };

            return API.setOTP(request)
                .then(function (response) {
                    console.log(response);

                    $scope.showSpinner = false;
                    if (response.status !== 1) {
                        return $q.reject()
                    }
                    $scope.user.otpEnabled = enable;

                    if (!$scope.user.otpEnabled) {
                        $scope.modal.textContent = LocaleService.translation.otpDisabled;
                    }
                    else{
                        $scope.modal.textContent = LocaleService.translation.otpVerified;
                    }
                    $scope.modal.textTitle = LocaleService.translation.successful;
                    $scope.modal.actionText = LocaleService.translation.close;
                    $scope.modal.isError = false;
                    $scope.modal.state = true;
                    $scope.modal.back = "root.app.menu";
                })
                .catch(function (error) {
                    $scope.showSpinner = false;

                    $scope.modal.isError = true;
                    $scope.modal.textTitle = LocaleService.translation.otpVerifyFailed;
                    $scope.modal.state = true;
                });
        };

        $scope.copyToClipBoard = function () {

            var input = (document.getElementsByClassName('gac-pandats'));
            HTMLCollection.prototype.isPrototypeOf(input) && input.length && (input = input[0]);

            if (input){
                input.select();
                input.setSelectionRange(0, $scope.otp.secret.length);
                document.execCommand('copy');
                input.blur();
                window.getSelection().removeAllRanges();

                ionicToast.show($scope.translation.copiedToCB, 'top', false, 5000, '');
            }

        }

    }]);
